module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_04-a1509a99040e30aa2206a413e41ccac6.png";